import { DSDatepicker } from '@vr/ds-react'

interface DatePeriodSelectProps {
  label: string
  onChange: (value: { rangeValues: { start: Date; end: Date } }) => void
  value?: string
  minDate?: Date
  maxDate?: Date
}

export const DatePeriodSelect = (props: DatePeriodSelectProps) => {
  const { onChange, minDate, maxDate, label, value } = props

  return (
    <DSDatepicker
      label={label}
      name={label}
      placeholder='Selecione um dia ou um intervalo de datas'
      disabled={false}
      showOtherMonthDays={true}
      range={true}
      value={value}
      minDate={minDate}
      maxDate={maxDate}
      onChange={event => {
        const { rangeValues } = event
        if (!rangeValues?.start || !rangeValues?.end) return

        const { start, end } = rangeValues
        onChange({
          rangeValues: {
            start: new Date(start),
            end: new Date(end)
          }
        })
      }}
    />
  )
}
